import { Plus, Users } from 'lucide-react';
import { useState } from 'react';
import { CapacityBracket } from '../../../types/capacity-brackets.types';
import { emptyBracket } from '../../../utils/capacity-brackets.utils';
import { BracketForm } from './BracketForm';
import { BracketRow } from './BracketRow';

interface CapacityBracketsSelectorProps {
  brackets: CapacityBracket[];
  onChange: (brackets: CapacityBracket[]) => void;
  data: any;
}

export function CapacityBracketsSelector({ brackets, onChange, data }: CapacityBracketsSelectorProps) {
  const [showAddForm, setShowAddForm] = useState(false);

  const handleUpdate = (index: number, updated: CapacityBracket) => {
    const next = [...brackets];
    next[index] = { ...updated, order: index };
    onChange(next);
  };

  const handleDelete = (index: number) => {
    onChange(brackets.filter((_, i) => i !== index).map((b, i) => ({ ...b, order: i })));
  };

  const handleAdd = (newBracket: CapacityBracket) => {
    onChange([...brackets, { ...newBracket, order: brackets.length }]);
    setShowAddForm(false);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {brackets.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <div style={{ fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '4px' }}>
            Tranches configurées ({brackets.length})
          </div>
          {brackets.map((bracket, index) => (
            <BracketRow
              key={bracket.id || bracket.label + index}
              bracket={bracket}
              onUpdate={(updated) => handleUpdate(index, updated)}
              onDelete={() => handleDelete(index)}
              data={data}
            />
          ))}
        </div>
      ) : (
        <div style={{ padding: '40px 24px', textAlign: 'center', background: '#f9fafb', border: '2px dashed #e5e7eb', borderRadius: '12px', color: '#9ca3af', fontSize: '14px' }}>
          <Users size={32} style={{ margin: '0 auto 12px', opacity: 0.4 }} />
          <div>Aucune tranche de capacité pour cet espace.</div>
          <div style={{ fontSize: '12px', marginTop: '4px' }}>Ajoutez une tranche ci-dessous.</div>
        </div>
      )}

      {showAddForm ? (
        <BracketForm
          initial={emptyBracket(brackets.length)}
          submitLabel="Ajouter la tranche"
          onSubmit={handleAdd}
          onCancel={() => setShowAddForm(false)}
          data={data}
        />
      ) : (
        <button
          type="button"
          style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 20px', fontSize: '14px', fontWeight: 500, color: '#00758d', backgroundColor: 'transparent', border: '2px dashed #00758d', borderRadius: '8px', cursor: 'pointer', alignSelf: 'flex-start', transition: 'background-color 0.15s ease' }}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#f0fdfa')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
          onClick={() => setShowAddForm(true)}
        >
          <Plus size={18} /> Ajouter une tranche de capacité
        </button>
      )}
    </div>
  );
}
